<template xmlns:th="http://www.w3.org/1999/xhtml">
    <div class="user">
<!--        <el-card class="noprint">-->
<!--            <el-page-header @back="goBack" :content="'签收单 ('+ id + ')'"></el-page-header>-->
<!--        </el-card>-->
        <main class="content">
            <div style="background: #fff; padding: 10px">
                <div style="margin-top: 3px;">
                    <table border="1" cellspacing="0" style="table-layout: fixed; width: 100%;font-size:13px">
                        <colgroup>
                            <col width="110"/>
                            <col width="130"/>
                            <col/>
                            <col width="160"/>
                            <col width="110"/>
                            <col width="80"/>
                            <col width="100"/>
                            <col width="110"/>
                            <col width="160"/>
                        </colgroup>
                        <tbody>
                            <tr style="width: 100%">
                                <td height="80" colspan="9" style="padding: 0 5px;text-align: center;font-weight: bold;font-size: 20px" >供货单<br>Delivery Note</td>
                            </tr>
                            <tr style="width: 100%;font-size: 15px;font-weight: normal" >
                                <th style="width: 120px;" class="thStyle">收货方：</th>
                                <td height="30" class="tdStyle" colspan="3" style="width: 467px;padding: 0 5px;" >{{allData.invoiceCompanyName}}</td>
                                <th style="width: 120px;" class="thStyle">发货方：</th>
                                <td colspan="4" height="30" class="tdStyle" style="width: 467px;padding: 0 5px;" >北京鹏龙天创物资贸易有限公司</td>
                            </tr>
                            <tr style="width: 100%">
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">交货地点：</th>
                                <td colspan="3"  class="tdStyle" style="width: 467px;padding: 0 5px;" height="30">{{allData.address}}</td>
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">发货联系人：</th>
                                <td style="width: 168px;padding: 0 5px;" class="tdStyle" height="30" colspan="2"></td>
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">电话：</th>
                                <td style="width: 167px;padding: 0 5px;" class="tdStyle"></td>
                            </tr>
                            <tr style="width: 100%">
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">采购订单号PO：</th>
                                <td colspan="3" style="width: 467px;padding: 0 5px;"  class="tdStyle" height="30">{{allData.orderNo}}</td>
                                <th style="width: 120px;" class="thStyle" >物流公司：</th>
                                <td colspan="4" style="width: 467px;padding: 0 5px;" ></td>
                            </tr>
                            <tr style="width: 100%">
                                <th style="width: 120px;" class="thStyle">采购工程师：</th>
                                <td colspan="3" style="width: 467px;padding: 0 5px;"  class="tdStyle" height="30" >{{allData.consignee}}</td>
                                <th style="width: 120px;" class="thStyle">物流单号：</th>
                                <td colspan="4" style="width: 467px;padding: 0 5px;"  class="tdStyle" ></td>
                            </tr>
                            <tr style="width: 100%">
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">技术工程师：</th>
                                <td colspan="3" style="width: 467px;padding: 0 5px;" height="30"  class="tdStyle" >{{allData.engineer}}</td>
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">物流联系人：</th>
                                <td style="width: 168px;padding: 0 5px;" colspan="2"></td>
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">电话：</th>
                                <td style="width: 167px;padding: 0 5px;"></td>
                            </tr>
                            <tr style="width: 100%">
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">收货人及电话：</th>
                                <td colspan="3" style="width: 467px;padding: 0 5px;" height="30" >{{allData.consignee+","+allData.mobile}}</td>
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">到货时间：</th>
                                <td colspan="4" style="width: 467px;padding: 0 5px;" ></td>
                            </tr>
                            <tr style="width: 100%;background: #dfdfdf;">
                                <th style="width: 60px">序号<br>Item</th>
                                <th style="width: 60px">物料号<br>SRM No.</th>
                                <th style="width: 120px">产品名称<br>Description</th>
                                <th style="width: 120px">型号&订货号<br>Type No.&Order No</th>
                                <th style="width: 120px">品牌<br>Brand</th>
                                <th style="width: 120px">单位<br>Unit</th>
                                <th style="width: 120px">总数量<br>Total quantity</th>
                                <th style="width: 120px">到货数量<br>Arrival quantity</th>
                                <th style="width: 120px">备注<br>Remark</th>
                            </tr>
                            <tr style="width: 100%" v-for="(detail,index) in tableData" v-bind:key="index">
                                <td style="padding: 0 5px;text-align: center">{{detail.number}}</td>
                                <td style="padding: 0 5px;text-align: center">{{detail.sku}}</td>
                                <td style="padding: 0 5px;text-align: center">{{detail.name}}</td>
                                <td style="padding: 0 5px;text-align: center">{{detail.model}}</td>
                                <td style="padding: 0 5px;text-align: center">{{detail.brand}}</td>
                                <td style="padding: 0 5px;text-align: center">{{detail.unit}}</td>
                                <td style="padding: 0 5px;text-align: center">{{detail.num}}</td>
                                <td style="padding: 0 5px;text-align: center">{{detail.num}}</td>
                                <td style="padding: 0 5px;text-align: center">{{detail.detailMemo}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style="margin-top: 20px; font-size: 14px; display: flex;">
                    <span style="flex-grow: 1;">送货人：</span>
                    <span style="flex-grow: 1;">收货人：</span>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import {convertRes2Blob, downloadByPost} from "../../utils/download";

    export default {

    data() {
        return {
            id: "",
            selectData:[],
            allData:{},
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
        }
    },
    methods: {
        onSearch() {
            this.loading = true;
            const that = this
            this.$axios.post("/admin/purchaseOrder/poDeliverDetail",this.id).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    const s = resp.data;
                    that.tableData = s.list;
                    that.allData = s;
                }
            }).finally(() => {
                that.loading = false;
            });
        },
        goBack() {
            this.$router.go(-1);
        },
    },
    created() {
        let paramsStore;
        const params = sessionStorage.getItem("params");
        if(params) {
            paramsStore = JSON.parse(params);
        }
        const { id } = JSON.stringify(this.$route.params)== "{}"?paramsStore:this.$route.params;
        this.id = id;
        this.onSearch()
    },
}
</script>
<style>
    /*表头换行 加这段代码*/
    .table ::v-deep.el-table th.el-table__cell > .cell {
        white-space: pre;
    }
    /*表格表头样式*/
    .table ::v-deep.el-table .el-table__cell {
        padding: 0px;
        min-width: 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        text-overflow: ellipsis;
        vertical-align: middle;
        position: relative;
        text-align: left;
    }
    .tdStyle{
        font-size: 13px;
        font-weight: normal
    }
    .thStyle{
        background: #dfdfdf;font-size:13px;text-align: left;padding-left: 5px;
    }

</style>
